Controller.$inject = ['$scope', '$element', '$timeout'];

function Controller($scope, $element, $timeout) {
    const self = this;

    self.hasEndContent = false;

    // Access parent hui-input-select controller
    self.getSelectCtrl = function() {
        return $scope.$parent.$inputSelectCtrl || $scope.$parent.$parent.$inputSelectCtrl;
    };

    // Get selection state directly from parent controller
    self.getIsSelected = function() {
        const selectCtrl = self.getSelectCtrl();
        return selectCtrl ? selectCtrl.isSelected(self.item) : false;
    };

    // Get multi-select state directly from parent controller  
    self.getMultiSelect = function() {
        const selectCtrl = self.getSelectCtrl();
        return selectCtrl ? selectCtrl.multiSelect : false;
    };

    self.handleClick = function(event) {
        if (!self.ngDisabled && self.item) {
            const selectCtrl = self.getSelectCtrl();
            if (selectCtrl && selectCtrl.selectItem) {
                selectCtrl.selectItem(self.item, event);
            }
            
            if (self.onClick) {
                self.onClick({$event: event, item: self.item});
            }
        }
    };

    self.$postLink = () => {
        $timeout(() => {
            const endContentWrapper = $element[0].querySelector('.hui-end-content-wrapper');
            self.hasEndContent = !!endContentWrapper?.innerHTML.trim();
        }, 0);
    };
}

export function HuiInputOption() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            item: '<',
            ngDisabled: '<',
            onClick: '&?',
            isGroupHeader: '<',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        link: function(scope, element, attrs, ctrl, transcludeFn) {
            if (attrs.ngDisabled) {
                scope.$watch(attrs.ngDisabled, function(newVal) {
                    ctrl.ngDisabled = newVal;
                });
            }
            
            if (transcludeFn) {
                transcludeFn(scope, function(clone) {
                    const contentContainer = element.find('.hui-select-option-content');
                    const endContentWrapper = element.find('.hui-end-content-wrapper');

                    clone.each(function() {
                        const isEndContent = this.nodeType === 1 &&
                                           (this.tagName === 'HUI-END-CONTENT' ||
                                            this.hasAttribute?.('hui-end-content'));

                        (isEndContent ? endContentWrapper : contentContainer).append(this);
                    });
                });
            }
        },
        template: () => {
            return `
                <div class="hui-menu-item hui-select-option"
                     role="option"
                     ng-attr-aria-disabled="{{$huiCtrl.ngDisabled}}"
                     ng-attr-tabindex="{{$huiCtrl.ngDisabled ? -1 : 0}}"
                     ng-class="{'active': !$huiCtrl.isGroupHeader && $huiCtrl.getIsSelected(),
                                'disabled': $huiCtrl.ngDisabled,
                                'hui-select-header': $huiCtrl.isGroupHeader}"
                     ng-click="$huiCtrl.isGroupHeader ? $event.stopPropagation() : $huiCtrl.handleClick($event)">
                    <div ng-if="!$huiCtrl.isGroupHeader && $huiCtrl.getMultiSelect()" class="hui-select-option-icon checkbox-icon">
                        <i class="fa fa-check"></i>
                    </div>
                    
                    <div ng-if="!$huiCtrl.isGroupHeader && !$huiCtrl.getMultiSelect() && $huiCtrl.hasEndContent" class="hui-select-option-icon radio-icon">
                        <div class="radio-inner"></div>
                    </div>
                    
                    <div class="hui-select-option-content" ng-class="{'hui-menu-header': $huiCtrl.isGroupHeader}"></div>

                    <div class="hui-end-content-wrapper" ng-if="$huiCtrl.hasEndContent"></div>

                    <div class="check-wrapper" ng-if="!$huiCtrl.getMultiSelect() && !$huiCtrl.hasEndContent">
                        <i class="fa fa-check text-primary"></i>
                    </div>
                </div>
            `;
        }
    };
}